var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-inline-svg',_vm._g(_vm._b({},'vue-inline-svg',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }